export default __webpack_public_path__ + "static/media/mail.160d3ff9.svg";